import { PositionType } from '../enums/positionType';
import * as _ from 'lodash';

export class Position {
    public type: PositionType;
    public x: number;
    public y: number;

    constructor();
    constructor(json: any);
    constructor(type: PositionType, x: number, y: number);
    constructor(typeOrJson?: any, x?: number, y?: number) {
        if (!_.isUndefined(typeOrJson) && !_.isNull(typeOrJson)) {
            if (x) {
                this.type = typeOrJson;
                this.x = x;
                this.y = y;
            } else {
                this.type = typeOrJson.type;
                this.x = typeOrJson.x;
                this.y = typeOrJson.y;
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/domain/models/position.ts